import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { vasthuUrl } from "../component/Api";
import { UseVasthu } from "../context/vasthu";
import PlotTable from "../component/plotTable";
import PlotMobileCard from "../component/plotMobileCard";
import { useLocation } from "react-router-dom";
import HelmetSeo from "../component/HelmetSeo";

const PlotScreen = () => {
  // const { token } = UseAuth();
  const token = window.sessionStorage.getItem("token");
  const langCode = window.localStorage.getItem("i18nextLng");
  const { plotRec } = UseVasthu();
  const [plotObj, setPlotObj] = useState({});
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setLoading(true);
    console.log("plotId", plotRec, typeof plotRec);
    console.log("navigate.params", location);
    // try{
    vasthuUrl
      .get(`/validateplotresult/${plotRec}/${langCode}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setPlotObj(res.data);
        setLoading(false);
        console.log("Plot record screen", res.data);
        vasthuUrl
          .get(
            `/subscription/useVasthuOffer/${parseInt(location.state.offerId)}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((rs) =>
            console.log("offer subscription redeem count used", rs.data.message)
          )
          .catch((er) =>
            console.log("offer subscription redeem count not reduced", er)
          );
      });
  }, [langCode, location, plotRec, token]);

  return (
    <Container>
      <HelmetSeo
        title="Plot Validation | Vasthuparam"
        content="Validate your land or plot details to receive accurate Vasthu insights based on direction, shape, and surrounding factors."
        name="description"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/plotvalidate"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/plotvalidate"
      />

      {!loading ? (
        <>
          <PlotTable data={plotObj} />
          <PlotMobileCard data={plotObj} />
        </>
      ) : (
        <div className="text-center">
          {" "}
          <Spinner animation="border" variant="warning" />{" "}
        </div>
      )}
      {/* <center>
        <Button
          variant="outline-warning"
          style={{ borderRadius: 50 }}
          onClick={() => navigate("/")}
        >
          FINISH
        </Button>
      </center> */}
    </Container>
  );
};

export default PlotScreen;
